/* eslint-disable */

/** unique or primary key constraints on table "argo.calendar_event" */
export enum ArgoCalendarEventConstraint {
  /** unique or primary key constraint on columns "calendar_event_id" */
  CalendarEventPkey = 'calendar_event_pkey'
}

/** select columns of table "argo.calendar_event" */
export enum ArgoCalendarEventSelectColumn {
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Day = 'day',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Range = 'range',
  /** column name */
  ScheduleEventId = 'schedule_event_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.calendar_event" */
export enum ArgoCalendarEventUpdateColumn {
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Day = 'day',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Range = 'range',
  /** column name */
  ScheduleEventId = 'schedule_event_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

